(() => {
  'use strict';
  if (window.UnchemedCXOffer) return;
  const initialized = new WeakSet();
  let busy = false;
  const format = cents => '$' + (Number(cents)/100).toLocaleString('en-US',{minimumFractionDigits:Number(cents)%100 ? 2:0,maximumFractionDigits:2});
  const interpolate = (str,values) => String(str || '').replace(/__([A-Z]+)__/g,(_,key) => values[key.toLowerCase()] ?? '');
  function init(scope = document) {
    scope.querySelectorAll('[data-cx-offer]').forEach(root => {
      if (initialized.has(root)) return;
      initialized.add(root);
      const context = window.UnchemedCXContext, form = root.querySelector('form'), button = root.querySelector('[data-cx-purchase]');
      if (!context) {button.disabled = true; return;}
      const product = context.product, copy = product.copy, get = selector => root.querySelector(selector), text = (selector,value) => {get(selector).textContent=value;};
      const v3 = root.hasAttribute('data-v3');
      const variant = key => product.variants.find(v => String(v.id) === context.ids[key]);
      let key = context.getSelected();
      let galleryKey = null;
      const highRes = source => {
        const url = new URL(source,document.baseURI);
        url.searchParams.set('width','1200');
        return url.href;
      };
      function syncCarousel() {
        if (galleryKey === key || !root.isConnected) return;
        const container = root.closest('.offer-card,[data-cx-home-offer]');
        const gallery = container?.querySelector('.gal');
        const homeImage = container?.querySelector('[data-cx-package-image]');
        if (!homeImage && (!gallery || !window.UnchemedGalleries?.setPackage)) return;
        const annual = key === 'annual', double = key === 'double';
        const description = copy[annual ? 'annual_image' : double ? 'double_image' : 'single_image'];
        const media = document.createElement('div'), photo = new Image();
        media.className = 'cx-carousel-media' + (annual ? ' cx-carousel-annual' : '');
        photo.className = 'cx-carousel-head';
        photo.src = highRes(double ? product.images.double : product.images.single);
        photo.alt = ''; photo.width = 1254; photo.height = 1254;
        photo.loading = 'eager'; photo.decoding = 'async'; photo.draggable = false;
        media.append(photo);
        if (annual) {
          const crop = document.createElement('span');
          crop.className = 'cx-carousel-refills';
          const filters = get('.cx-filter-crop').cloneNode(true);
          filters.querySelector('img').loading = 'eager';
          crop.append(filters); media.append(crop);
        }
        media.querySelectorAll('img').forEach(img => img.setAttribute('aria-hidden','true'));
        if (homeImage) {
          media.setAttribute('role','img');media.setAttribute('aria-label',description);
          homeImage.replaceChildren(media);galleryKey=key;
          return;
        }
        const thumbnail = media.cloneNode(true);
        thumbnail.setAttribute('aria-hidden','true');
        if (window.UnchemedGalleries.setPackage(gallery,media,thumbnail,description)) galleryKey = key;
      }
      function render() {
        const item = variant(key), starter = variant('starter'), annual = variant('annual'), double = variant('double');
        context.setSelected(key);
        root.dataset.offer = key; root.dataset.productId = String(product.id); root.dataset.variantId = String(item.id); root.dataset.value = String(item.price/100); root.dataset.quantity = '1';
        form.elements.id.value=String(item.id); form.elements.quantity.value='1';
        const compareOf = v => v && Number(v.compare) > Number(v.price) ? Number(v.compare) : 0;
        const was = compareOf(item);
        if (v3) {
          root.querySelectorAll('.v3-opt').forEach(option => {const radio=option.querySelector('input[type=radio]');radio.checked=radio.value===key;radio.disabled=busy;option.classList.toggle('is-selected',radio.checked);});
          root.querySelectorAll('[data-v3-under]').forEach(node => {node.hidden=node.dataset.v3Under!==key;});
        } else {
        form.querySelectorAll('input[type=radio]').forEach(radio => {radio.checked=radio.value===key;radio.disabled=busy;radio.closest('.cx-option').classList.toggle('is-selected',radio.checked);});
        Object.keys(context.ids).forEach(k => {
          const v = variant(k), node = get('[data-card-price="'+k+'"]'), was = compareOf(v), now = document.createElement('span');
          now.className = 'cx-option-now'; now.textContent = format(v.price);
          if (was) {const old = document.createElement('s'); old.className = 'cx-option-compare'; old.textContent = format(was); node.replaceChildren(old,now);} else node.replaceChildren(now);
        });
        const annualWas = compareOf(annual), doubleWas = compareOf(double);
        text('[data-detail="starter"]',copy.starter_detail);
        text('[data-detail="annual"]',annualWas ? interpolate(copy.annual_detail,{amount:format(annualWas-annual.price)}) : copy.annual_save);
        text('[data-detail="double"]',interpolate(copy.double_detail,{unit:format(double.price/2),total:format(double.price),amount:format(doubleWas ? doubleWas-double.price : Math.max(starter.price*2-double.price,0))}));
        text('[data-total]',format(item.price));
        get('[data-compare]').hidden=!was;
        text('[data-compare]',was ? format(was) : '');
        const saving = was ? interpolate(copy.save,{amount:format(was-item.price)}) : key==='annual' ? copy.annual_save : key==='double' && starter.price*2>double.price ? interpolate(copy.double_save,{amount:format(starter.price*2-double.price)}) : '';
        text('[data-savings]',saving);get('[data-savings]').hidden=!saving;
        const isDouble=key==='double',isAnnual=key==='annual',source=isDouble ? product.images.double : product.images.single;
        if (get('[data-head]').getAttribute('src')!==source) get('[data-head]').src=source;
        get('[data-head-wrap]').classList.toggle('cx-double',isDouble);get('[data-refills]').hidden=!isAnnual;
        get('[data-gallery]').setAttribute('aria-label',copy[isAnnual ? 'annual_image' : isDouble ? 'double_image' : 'single_image']);
        text('[data-first-label]',copy[isDouble ? 'double_label' : 'single_label']);
        text('[data-includes-title]',copy[key+'_title']);text('[data-includes]',copy[key+'_contents']);get('[data-duration]').hidden=!isAnnual;
        }
        const available=item.available && product.currency==='USD' && Boolean(window.UnchemedCommerce?.openOfferCheckout);
        button.disabled=busy || !available;button.setAttribute('aria-busy',String(busy));
        button.textContent=busy ? copy.opening : interpolate(copy[item.available ? 'add':'sold_out'],{price:format(item.price)});
        text('[data-status]',product.currency!=='USD' ? copy.currency : item.available ? '' : copy.unavailable);
        if (product.productLandingPage) {
          document.querySelectorAll('[data-cx-page-total]').forEach(node => {
            const now = document.createTextNode(format(item.price));
            if (was) {const old = document.createElement('s'); old.className = 'unc-cx-sticky-compare'; old.textContent = format(was); node.replaceChildren(now,' ',old);} else node.replaceChildren(now);
          });
          document.querySelectorAll('[data-cx-page-name]').forEach(node => {node.textContent=item.title || item.name;});
        }
        syncCarousel();
      }
      form.addEventListener('change',event => {
        if (!event.target.matches('input[type=radio]') || busy || !context.ids[event.target.value]) return;
        key=event.target.value;get('.unc-checkout-error').hidden=true;render();
        document.dispatchEvent(new CustomEvent('unc:cx-offer-change',{detail:{key,productId:String(product.id)}}));
      });
      function submit(event) {
        event.preventDefault();
        if (busy || button.disabled || !variant(key).available) return;
        window.UnchemedCommerce.openOfferCheckout(form,product,context.ids[key]);
      }
      button.addEventListener('click',submit);form.addEventListener('submit',submit);
      document.addEventListener('unc:commerce-state',event => {busy=Boolean(event.detail.busy);render();});
      document.addEventListener('unc:cx-offer-change',event=>{if(event.detail.productId===String(product.id)&&context.ids[event.detail.key]){key=event.detail.key;render();}});
      window.addEventListener('pageshow',()=>{busy=false;key=context.getSelected();render();});
      document.addEventListener('unc:galleries-ready',syncCarousel);
      render();
      const preload = new Image();preload.src=product.images.double;
      [product.images.single,product.images.double].forEach(source => {const image=new Image();image.src=highRes(source);});
    });
  }
  window.UnchemedCXOffer = Object.freeze({init,version:'2026-10-08.v3'});
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(),{once:true}); else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();

